/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const COLLECTION_CLIP_CANDIDATE_SOURCES = ['match', 'extract'] as const;
export const collectionClipCandidateSourceSchema = z.enum(COLLECTION_CLIP_CANDIDATE_SOURCES);
export type ICollectionClipCandidateSource = z.infer<typeof collectionClipCandidateSourceSchema>;

export const CHALLENGE_CLIP_SOURCES = ['match', 'extract', 'manual', 'requested'] as const;
export const challengeClipSourceSchema = z.enum(CHALLENGE_CLIP_SOURCES);
export type IChallengeClipSource = z.infer<typeof challengeClipSourceSchema>;

export const CHALLENGE_CLIP_SOURCE_LABELS: Record<IChallengeClipSource, string> = {
  match: 'Match',
  extract: 'AI',
  manual: 'Manual',
  requested: 'Requested',
};
